import React, { Component } from 'react';
import { compose } from 'redux';

import Pagination from 'components/Pagination/Pagination';
import LoginDevicesList from 'components/LoginDevicesList/LoginDevicesList';
import userPage from 'decorators/userPage';
import withLoginDevices from 'decorators/withLoginDevices';

class LoginDevices extends Component {
  componentDidMount() {
    this.redirectToViewUserPage();
  }

  componentDidUpdate() {
    this.redirectToViewUserPage();
  }

  redirectToViewUserPage = () => {
    const { user, isResellerOrAdminOrManager, history } = this.props;
    if (user && !isResellerOrAdminOrManager) {
      history.push(`/users/${user.id}/view`);
    }
  };

  render() {
    const { loginDevices, pageCount, page } = this.props;

    return (
      <div>
        <h1>Login Devices</h1>
        <LoginDevicesList loginDevices={loginDevices} />
        <Pagination
          count={pageCount}
          current={page}
          url={(pageNum) => `/users/392/login-devices?page=${pageNum}`}
        />
      </div>
    );
  }
}

export default compose(userPage, withLoginDevices)(LoginDevices);
